/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ChipProps, RAGPillColours } from '@components-clean/core/grid/custom-cell/chip-constants';
import { ColumnDefinition } from '@interfaces/central-monitoring';

const gridColumns = {
    TimePeriod: 'bin_label_date',
    YValue: 'y_value',
    NumeratorValue: 'numerator_events',
    DenominatorValue: 'denominator_value',
    ScaleBy: 'scale_by',
    Status: 'colour_direction_threshold',
    OutOfTolerance: 'out_of_tolerance',
    OutOfToleranceType: 'out_of_tolerance_desc',
    OutOfToleranceValue: 'out_of_tolerance_value',
    ToleranceLimits: 'tolerance_limits',
    Benchmark: 'benchmark_value',
    UpperRed: 'upper_red_value',
    UpperAmber: 'upper_amber_value',
    LowerAmber: 'lower_amber_value',
    LowerRed: 'lower_red_value',
    PlotCalculations: 'plot_calculation',
    NoOfSubjects: 'unique_subjects_in_bin',
    ExpectedValue: 'expected_volume',
};

const ragChips: ChipProps[] = [
    {
        text: 'Upper Red',
        value: 'Upper Red',
        backgroundColor: RAGPillColours.ragRed,
        borderColor: RAGPillColours.ragRedBorder,
    },
    {
        text: 'Upper Amber',
        value: 'Upper Amber',
        backgroundColor: RAGPillColours.ragAmber,
        borderColor: RAGPillColours.ragAmberBorder,
    },
    {
        text: 'Lower Amber',
        value: 'Lower Amber',
        backgroundColor: RAGPillColours.ragAmber,
        borderColor: RAGPillColours.ragAmberBorder,
    },
    {
        text: 'Lower Red',
        value: 'Lower Red',
        backgroundColor: RAGPillColours.ragRed,
        borderColor: RAGPillColours.ragRedBorder,
    },
    {
        text: 'None',
        value: 'None',
        backgroundColor: RAGPillColours.ragNone,
        borderColor: RAGPillColours.ragNoneBorder,
    },
    {
        text: 'Below Min Data',
        value: 'Below Min Data',
        backgroundColor: RAGPillColours.ragGrey,
        borderColor: RAGPillColours.ragGreyBorder,
    },
    {
        text: 'Green',
        value: 'Green',
        backgroundColor: RAGPillColours.ragGreen,
        borderColor: RAGPillColours.ragGreenBorder,
    },
];

export class ControlsHubPanelGridHelper implements IGridHelper {
    private _customCells: CustomCells;

    constructor(private customCells: CustomCells) {
        this._customCells = customCells;
    }

    getDisplayFields() {
        return true;
    }

    getActiveField() {
        return undefined;
    }

    getDisplayTooltipFields() {
        return false;
    }

    isRagColumn() {
        return false;
    }

    disableLock() {
        return false;
    }

    multiValueFilter() {
        return false;
    }

    getColumnWidth() {
        return undefined;
    }

    getCustomCell(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case gridColumns.Status:
            case gridColumns.OutOfToleranceType:
                return this._customCells.ChipCell(ragChips, { width: 115 });
            default:
                return undefined;
        }
    }

    disableAdvancedFilter() {
        return false;
    }
}
